import { render, staticRenderFns } from "./ClientWallets.vue?vue&type=template&id=306a0f80"
import script from "./ClientWallets.vue?vue&type=script&lang=js"
export * from "./ClientWallets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports